<template>
  <div class="container">
    <titular />
    <Gis scope="https://www.googleapis.com/auth/calendar.readonly" :parentAccessToken="accessToken" @cambiarAutorizacion="cambiarAutorizacion" />
    <div v-if="accessToken" class="mt-3">
      <div class="row mb-4">
        <div class="col-12 col-md-6 col-lg-4 mx-auto">
          <form @submit.prevent="verSemana">
            <label for="proyecto">Setmana a revisar</label>
            <div class="input-group">
              <div class="input-group-prepend">
                <div class="input-group-text"><i class="fa-solid fa-calendar-week" title="Setmana" v-tooltip></i></div>
              </div>
              <input type="week" class="form-control" v-model="semana" @change="submitForm" required>
            </div>
            <input type="submit" hidden />
          </form>
        </div>
      </div>
      <div v-if="semana">
        <div class="row mb-3">
          <div class="col-12">
            <ul class="list-inline">
              <li class="list-inline-item">
                <modal ref="enviarFeedback" titulo="Enviar feedback" icono="fa-solid fa-paper-plane" btnClass="btn-primary" :hayLanzador="true" modalId="enviarFeedback" :loading="loading.enviarFeedback">
                  <template v-slot:body>
                    <form id="formEnviarFeedback" @submit.prevent="enviarFeedback">
                      <fieldset :disabled="loading.enviarFeedback">
                        <div class="table-responsive">
                          <table class="table table-sm table-hover">
                            <thead class="text-nowrap">
                              <tr>
                                <th></th>
                                <th scope="col" class="text-center">Mínim PDs</th>
                                <th scope="col" class="text-center">Mínim 70%</th>
                                <th scope="col" class="text-center">Dilluns 100%</th>
                                <th scope="col" class="text-center">Inici dies</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(trabajador, trabajadorIndex) in fallidos" :key="trabajadorIndex">
                                <td>
                                  <input type="checkbox" ref="feedbackGlobal" v-model="trabajador.feedbackGlobal" @change="cambiarFeedback(trabajadorIndex)"> {{ trabajador.nombre_completo }}
                                </td>
                                <td v-for="(condicion, condicionesIndex) in trabajador.condiciones" :key="condicionesIndex" class="text-center">
                                  <input type="checkbox" v-model="trabajador.feedback[condicionesIndex]" @change="cambiarFeedbackGlobal(trabajadorIndex)">
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </fieldset>
                    </form>
                  </template>
                  <template v-slot:footer>
                    <button form="formEnviarFeedback" type="submit" class="btn btn-primary" :disabled="loading.enviarFeedback">
                      <i-submit icono="fa-paper-plane" :loading="loading.enviarFeedback" />Confirmar
                    </button>
                  </template>
                </modal>
              </li>
            </ul>
          </div>
        </div>
        <div class="row">
          <div class="col-12">
            <div class="table-responsive">
              <table class="table table-sm table-striped table-hover">
                <thead class="text-nowrap">
                  <tr>
                    <th></th>
                    <th scope="col" class="text-center" title="Que hi hagi com a mínim un número de PDs igual o superior a (%jornada * 5), arrodonit a l'alça" v-tooltip>Mínim PDs</th>
                    <th scope="col" class="text-center" title="Que hi hagi programat (franges amb contingut de text) com a mínim el 70% del temps (0.7 * 40 hores * %jornada)" v-tooltip>Mínim 70%</th>
                    <th scope="col" class="text-center" title="Que el PD del dilluns estigui 100% programat (sense hores, franges en blanc)" v-tooltip>Dilluns 100%</th>
                    <th scope="col" class="text-center" title="Que el 100% dels PDs calculats a la condició 1 (arrodonit a l'alça) no tingui franges sense programar (sense hores, franges en blanc) al principi del PD." v-tooltip>Inici dies</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(trabajador, index) in trabajadores" :key="index">
                    <td class="d-flex justify-content-between">
                      <span>{{ trabajador.nombre_completo }}</span>
                      <span>
                        <span class="badge badge-danger" :class="{ 'opacity-50': !trabajador.condiciones.filter(a => a === false).length }"><i class="fa-solid fa-xmark fa-fw"></i> {{ trabajador.condiciones.filter(a => a === false).length }}</span>
                      </span>
                    </td>
                    <td class="text-center">
                      <Condicion :status="trabajador.condiciones[0]" />
                    </td>
                    <td class="text-center">
                      <Condicion :status="trabajador.condiciones[1]" />
                    </td>
                    <td class="text-center">
                      <Condicion :status="trabajador.condiciones[2]" />
                    </td>
                    <td class="text-center">
                      <Condicion :status="trabajador.condiciones[3]" />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
      <div v-else>
        <vacio>Utilitza el formulari superior per veure dades.</vacio>
      </div>
    </div>
    <div v-else class="container">
      <div class="row">
        <div class="col text-center text-muted">
          <i class="fas fa-10x mb-5 fa-unlock"></i>
          <div class="alert alert-warning" role="alert"><i class="fas fa-exclamation-triangle mr-1"></i>Si us plau, autoritza l'accés d'aquesta app a un compte Google que pugui veure els calendaris.</div>
        </div>
      </div>
    </div>
  </div>
</template>
      
<script>
import Gis from "../components/GIS.vue";
import htmlToFormattedText from "html-to-formatted-text";
import Condicion from "../components/Condicion.vue";
export default {
  name: "revisorProgramacio",
  inject: ["calcularFranja", "comprobarFranjaValida"],
  components: {
    Gis,
    Condicion,
  },
  data() {
    return {
      loading: {
        enviarFeedback: false,
      },
      trabajadores: [],
      accessToken: null,
      semana: null,
    };
  },
  computed: {
    dayMin() {
      if (!this.semana) return;

      let year = this.anyoSeleccionado;
      let week = this.semanaSeleccionada;
      let day = (1 + (week - 1) * 7); // 1st of January + 7 days for each week
      let dayOffset = new Date(year, 0, 1).getDay(); // we need to know at what day of the week the year start

      dayOffset--;  // depending on what day you want the week to start increment or decrement this value. This should make the week start on a monday

      return new Date(year, 0, day - dayOffset);  // Lunes
    },
    dayMax() {
      if (!this.semana) return;

      let year = this.anyoSeleccionado;
      let week = this.semanaSeleccionada;
      let day = (1 + (week - 1) * 7);
      let dayOffset = new Date(year, 0, 1).getDay();

      dayOffset--;

      return new Date(year, 0, day - dayOffset + 6);  // Domingo
    },
    semanaSeleccionada() {
      if (!this.semana) return;

      return parseInt(this.semana.slice(6), 10);
    },
    anyoSeleccionado() {
      if (!this.semana) return;

      return parseInt(this.semana.slice(0, 4), 10);
    },
    fallidos() {
      return this.trabajadores.filter(trabajador => trabajador.condiciones.some(a => a === false));
    },
  },
  created() {
    this.accessToken = localStorage.getItem("calendarToken");

    this.$http.get("api/treballadors?google_calendar&order=nom").then(response => this.trabajadores = response.data.map(a => ({
      ...a,
      condiciones: [null, null, null, null],
      feedback: [false, false, false, false],
      feedbackGlobal: false,
      eventos: []
    })));
  },
  methods: {
    cambiarFeedback(fallidoIndex) {
      this.fallidos[fallidoIndex].feedback.forEach((a, i) => this.$set(this.fallidos[fallidoIndex].feedback, i, this.fallidos[fallidoIndex].feedbackGlobal));
    },
    cambiarFeedbackGlobal(index) {
      const todosOK = this.fallidos[index].feedback.every(feedback => feedback);
      const todosKO = this.fallidos[index].feedback.every(feedback => !feedback);

      if (todosOK) {
        this.fallidos[index].feedbackGlobal = true;
      } else if (todosKO) {
        this.fallidos[index].feedbackGlobal = false;
      }

      this.$refs.feedbackGlobal[index].indeterminate = !todosOK && !todosKO;
    },
    verSemana() {
      if (!this.accessToken) return;

      this.trabajadores.forEach((trabajador, ti) => {
        fetch(`https://www.googleapis.com/calendar/v3/calendars/${trabajador.email_calendar}/events?${new URLSearchParams({
          timeMin: this.dayMin.toISOString(),
          timeMax: this.dayMax.toISOString(),
          showDeleted: false,
          singleEvents: true,
          orderBy: "startTime",
        })}`, {
          headers: {
            'Authorization': `Bearer ${this.accessToken}`,
          },
        })
          .then(response => {
            if (response.status == 401) {
              this.accessToken = null
            }

            return response;
          })
          .then(response => response.json())
          .then(response => {
            if (!response.items) return;

            var i;
            var events = response.items;
            var eventos = [];
            var totalPDs = 0;

            for (i = 0; i < events.length; i++) {
              var event = events[i];

              if (!event.summary || (event.summary && event.summary.substring(0, 2).toLowerCase() != "pd")) continue;

              var tareas = htmlToFormattedText(event.description)
                .replaceAll(/\u00a0/g, " ")
                .split("\n");
              var when = event.start.dateTime;

              if (!when) {
                when = event.start.date;
              }

              tareas.forEach(element => {
                if (element.length) {
                  let horas = element.split(/(^\s?((([0-1]{0,1}[0-9])|(2[0-3]))(([:\.]{1})[0-5]{0,1}[0-9]){1})(\s?[\-–]\s?)((([0-1]{0,1}[0-9])|(2[0-3]))(([:\.]{1})[0-5]{0,1}[0-9]){1})(\s?h\s?)?)/);

                  if (horas.length > 1) {
                    let texto_sin_horas = element.replace(horas[1], "");
                    let primera_hora = horas[2];
                    let segunda_hora = horas[horas.findIndex((str) => /^\s?[\-–]\s?$/.test(str)) + 1];
                    let franja_calculada = this.calcularFranja(primera_hora, segunda_hora);

                    eventos.push({
                      fecha: new Date(when).toDateString(),
                      diaSemana: new Date(when).getDay(),
                      franja: franja_calculada !== null ? franja_calculada.diferencia : 0,
                      franjaInicial: franja_calculada !== null ? franja_calculada.horaInicio : null,
                      franjaFinal: franja_calculada !== null ? franja_calculada.horaFinal : null,
                      franjaValida: franja_calculada !== null ? this.comprobarFranjaValida(franja_calculada.diferencia) : false,
                      vacio: !texto_sin_horas.trim(),
                      texto: element,
                    });
                  }
                }
              });

              totalPDs++;
            }

            this.$set(this.trabajadores[ti], "eventos", eventos);

            let totalDias = [...new Set(eventos.map(value => value.fecha))].length;
            var fechaAnterior = null;

            this.$set(this.trabajadores[ti].condiciones, 0, totalPDs >= Math.round((5 * parseFloat(this.trabajadores[ti].jornada)) / 100));
            this.$set(this.trabajadores[ti].condiciones, 1, eventos.filter(evento => !evento.vacio).reduce((a, b) => a + b.franja, 0) >= Math.round((0.7 * 40) * (parseFloat(this.trabajadores[ti].jornada) / 100)));
            this.$set(this.trabajadores[ti].condiciones, 2, eventos.filter(evento => evento.diaSemana == 1).length > 0 && !eventos.filter(evento => evento.diaSemana == 1).some(evento => evento.vacio));
            this.$set(this.trabajadores[ti].condiciones, 3, totalPDs > 0 && totalPDs == totalDias && !eventos.filter(e => {
              const r = e.fecha != fechaAnterior;

              fechaAnterior = e.fecha;

              return r;
            }).some(evento => evento.vacio));

            this.$set(this.trabajadores[ti].feedback, 0, !this.trabajadores[ti].condiciones[0]);
            this.$set(this.trabajadores[ti].feedback, 1, !this.trabajadores[ti].condiciones[1]);
            this.$set(this.trabajadores[ti].feedback, 2, !this.trabajadores[ti].condiciones[2]);
            this.$set(this.trabajadores[ti].feedback, 3, !this.trabajadores[ti].condiciones[3]);
            this.trabajadores[ti].feedbackGlobal = true;
          })
          .catch(error => console.error(error));
      });
    },
    submitForm(e) {
      e.target.form.querySelector('[type="submit"]').click();
    },
    cambiarAutorizacion(value) {
      this.accessToken = value;
    },
    enviarFeedback() {
      this.$toast.clear();

      if (!this.fallidos.some(fallido => fallido.feedback.some(a => a))) return this.$toast.open({ type: "warning", position: "top", message: `No s'ha seleccionat cap feedback a enviar.` });

      this.loading.enviarFeedback = true;

      this.$http
        .post("api/treballadors", {
          feedback: this.fallidos.filter(fallido => fallido.feedback.some(a => a)).map(fallido => ({
            "nombre": fallido.nom,
            "email": fallido.email_calendar,
            "incidencias": fallido.feedback,
          })),
          inicio: this.dayMin.toLocaleDateString(),
          fin: this.dayMax.toLocaleDateString(),
        })
        .then((response) => {
          if (response.status == 200) {
            this.$http
              .put("api/revisions", {
                setmana: this.semanaSeleccionada,
                any: this.anyoSeleccionado,
                revisions: this.fallidos.map(fallido => ({
                  id_treballador: fallido.id,
                  criteri_1: fallido.feedback[0] ? 1 : 0,
                  criteri_2: fallido.feedback[1] ? 1 : 0,
                  criteri_3: fallido.feedback[2] ? 1 : 0,
                  criteri_4: fallido.feedback[3] ? 1 : 0,
                }))
              })
              .then(() => {
                this.$refs[`enviarFeedback`].cerrar();

                this.$toast.open({ position: "top", message: `Feedback enviat correctament.` });
              });
          }
        })
        .finally(this.loading.enviarFeedback = false);
    },
  },
  watch: {
    accessToken(value) {
      if (value) {
        localStorage.setItem("calendarToken", value);
      } else {
        localStorage.removeItem("calendarToken");

        this.semana = null;
      }
    },
  },
};
</script>
  
<style lang="scss" scoped>
.opacity-50 {
  opacity: 0.5;
}
</style>